import { useQuery } from '@tanstack/react-query';

import { apiErrorMessage } from '../../shared/api/errors';
import { ErrorText, PageHeader, Spinner } from '../../shared/ui/primitives';
import { getStats } from './api';

export function DashboardPage() {
  const stats = useQuery({ queryKey: ['admin', 'stats'], queryFn: getStats });

  return (
    <section className="space-y-5">
      <PageHeader title="Дашборд" />

      {stats.isLoading && <Spinner />}
      {stats.isError && <ErrorText>{apiErrorMessage(stats.error)}</ErrorText>}

      {stats.data && (
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
          <Stat label="Пользователи" value={stats.data.users} />
          <Stat label="Врачи" value={stats.data.doctors} />
          <Stat label="Администраторы" value={stats.data.admins} />
          <Stat label="Пациенты" value={stats.data.patients} />
          <Stat label="Клиники" value={stats.data.clinics} />
          <Stat label="Обследования" value={stats.data.examinations} />
        </div>
      )}
    </section>
  );
}

function Stat({ label, value }: { label: string; value: number }) {
  return (
    <div className="rounded-xl border border-line bg-surface p-3 shadow-sm">
      <p className="text-2xl font-semibold text-primary">{value}</p>
      <p className="text-xs text-muted">{label}</p>
    </div>
  );
}
